var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** Centered streamgraph stack — layers sum to a smooth filled band per series. */
export function layoutStreamgraph(series, width, height, pad) {
    var _a;
    if (pad === void 0) { pad = { left: 24, right: 24, top: 12, bottom: 12 }; }
    var n = series.length;
    if (!n)
        return [];
    var len = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(series.map(function (s) { return s.length; })), false), [1], false));
    var plotW = Math.max(width - pad.left - pad.right, 8);
    var plotH = Math.max(height - pad.top - pad.bottom, 8);
    var midY = pad.top + plotH / 2;
    var totals = Array.from({ length: len }, function (_, i) {
        return series.reduce(function (a, s) { var _a; return a + ((_a = s[i]) !== null && _a !== void 0 ? _a : 0); }, 0);
    });
    var maxTotal = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(totals), false), [1], false));
    var yScale = plotH / maxTotal;
    var tops = series.map(function () { return Array(len).fill(0); });
    var bots = series.map(function () { return Array(len).fill(0); });
    for (var i = 0; i < len; i++) {
        var totalH = totals[i] * yScale;
        var y = midY - totalH / 2;
        for (var s = 0; s < n; s++) {
            var h = ((_a = series[s][i]) !== null && _a !== void 0 ? _a : 0) * yScale;
            bots[s][i] = y;
            tops[s][i] = y + h;
            y += h;
        }
    }
    var xAt = function (i) { return pad.left + (plotW * i) / Math.max(len - 1, 1); };
    return series.map(function (_, si) {
        var topPts = [];
        var botPts = [];
        for (var i = 0; i < len; i++) {
            var x = xAt(i);
            topPts.push("".concat(x, ",").concat(tops[si][i]));
            botPts.unshift("".concat(x, ",").concat(bots[si][i]));
        }
        var d = "M ".concat(topPts.join(' L '), " L ").concat(botPts.join(' L '), " Z");
        return { path: d, index: si };
    });
}
/** Multi-line tooltip label for streamgraph at index i. */
export function streamTooltipLabel(series, index, names) {
    return series
        .map(function (s, si) { var _a, _b; return "".concat((_a = names === null || names === void 0 ? void 0 : names[si]) !== null && _a !== void 0 ? _a : "S".concat(si + 1), ": ").concat((_b = s[index]) !== null && _b !== void 0 ? _b : 0); })
        .join('\n');
}
